module.exports = __webpack_public_path__ + "static/media/background-login.98b49e72.png";